<template>
    <rkm-content>
        <rkm-content-header :title="$route.meta.title">
            <template
                v-if="authorize('administracao-envio-sms-store')"
                v-slot:actions
            >
                <rkm-button
                    :to="{name: 'administracao-envio-sms-create'}"
                    color="primary"
                >
                    Escrever mensagem
                </rkm-button>
            </template>
        </rkm-content-header>

        <rkm-content-body>
            <rkm-container>
                <List />
            </rkm-container>
        </rkm-content-body>
    </rkm-content>
</template>

<script>
// Components.
import List from '@/components/administracao/envio-sms/List'

// Mixins.
import {authorization} from '@/mixins'

export default {
    components: {List},
    mixins: [authorization],
}
</script>